import { render, staticRenderFns } from "./GerenciaCadastroCalendario.vue?vue&type=template&id=69b2a955"
import script from "./GerenciaCadastroCalendario.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroCalendario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports